import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { feeEngineEndpoints } from "@/features/fee-engine/api/endpoints";
import type {
  CompanySubscriptionDto,
  CompanySubscriptionFilter,
} from "@/features/fee-engine/api/dto";

/** Liste paginée des abonnements entreprise (`POST /CompanySubscriptions/all`). */
export const useCompanySubscriptions = (
  params: ListRequest<CompanySubscriptionFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.FEE_COMPANY_SUBSCRIPTIONS_LIST(params),
    queryFn: () =>
      mutateData({
        url: feeEngineEndpoints.companySubscriptions.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<CompanySubscriptionDto>>,
    enabled,
  });
